import { render } from "./ProfessionalTable.vue?vue&type=template&id=7fb08eb8&scoped=true"
import script from "./ProfessionalTable.vue?vue&type=script&lang=js"
export * from "./ProfessionalTable.vue?vue&type=script&lang=js"

import "./ProfessionalTable.vue?vue&type=style&index=0&id=7fb08eb8&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb08eb8"]])

export default __exports__